const LocalStorageKey = {
  APP_STORAGE_PREFIX:
    typeof window !== 'undefined'
      ? `leonardo_${window.location.hostname}_`
      : 'leonardo_',
  USER_PROFILE: 'userProfile',
  AMAZON_STATE: 'amazon_state',
  LINKEDIN_STATE: 'linkedin_state',
  HUBSPOT_STATE: 'hubspot_state',
  TIKTOK_STATE: 'tiktok_state',
  GOOGLE_ADS_STATE: 'google_ads_state',
  REDDIT_STATE: 'reddit_state',
  BING_ADS_STATE: 'bing_ads_state',
  SHOPIFY_STATE: 'shopify_state',
  GOHIGHLEVEL_STATE: 'gohighlevel_state',
  SLACK_STATE: 'slack_state',
  VERIFY_USER_EMAIL: 'verify_user_email',
  MASQUERADE_USER: 'masquerade_user',
  MASQUERADE_OPERATOR_EMAIL: 'masquerade_operator_email',
  SURVEY_FORM_VALUES: 'survey_form_values',
  ACCESS_TOKEN_EXPIRES: 'access_token_expires',
  // Multi-tab workspace sync - stores JSON with {workspaceId, companyName, timestamp}
  WORKSPACE_CONTEXT_CHANGE: 'workspace_context_change',
  WORKSPACE: 'workspace',
  PROMOTER_CODE: 'promoter_code',
  SIDEBAR_AD_FILTERS: 'sidebar_ad_filters',
  WELCOME_BRIEF_EXPLORED: 'welcome_brief_explored',
  PROFESSIONAL_ROLE: 'leo_professional_role',
  PREFERRED_PLATFORMS: 'leo_preferred_platforms',
  ACCOUNT_TYPE: 'leo_account_type',
  AGENCY_FOCUS: 'leo_agency_focus',
} as const;

type LocalStorageKey = (typeof LocalStorageKey)[keyof typeof LocalStorageKey];

export default LocalStorageKey;
